import { Record, Map } from 'immutable';

const CurrentUserRecord = Record({
  id: undefined,
  _links: new Map(),
  _forms: new Map()
});

class CurrentUser extends CurrentUserRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default CurrentUser;


// WEBPACK FOOTER //
// ./src/api/models/currentUser.js